import { OverallShareItem, ShareOfVoiceInsights } from '@/common/model/media/shareOfVoice'

// シェア・オブ・ボイス分析の analysis_type 識別子
export const SHARE_OF_VOICE_ANALYSIS_TYPE = 'share_of_voice'

// 競合は最大5社まで
export const MAX_COMPETITORS = 5

// チャートの系列色（自社→競合の順で割り当て）
export const SHARE_OF_VOICE_COLORS = [
  '#6366f1',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#06b6d4',
  '#ec4899',
  '#14b8a6'
] as const

// 系列色を循環で取得
export const shareColor = (index: number): string =>
  SHARE_OF_VOICE_COLORS[index % SHARE_OF_VOICE_COLORS.length]

// 円グラフ用に { label, value } へ整形
export const toPieItems = (chart: OverallShareItem[]): { label: string; value: number }[] =>
  chart.map((item) => ({ label: item.brand, value: item.share }))

// インサイトのクエリ値を常に配列へ正規化
export const toQueryList = (value: string | string[] | undefined): string[] => {
  if (!value) return []
  return Array.isArray(value) ? value : [value]
}

// インサイトに表示すべき内容があるか
export const hasInsights = (insights: ShareOfVoiceInsights | null): boolean => {
  if (!insights) return false
  return (
    toQueryList(insights.dominant_queries).length > 0 ||
    toQueryList(insights.weak_queries).length > 0 ||
    !!insights.recommendation
  )
}
